import makeStyles from "@mui/styles/makeStyles";
import { SURVEY_COLORS } from "../../../shared/theme-constants";
import { getSharedStyles } from "../../../shared/shared-styles";

interface TrainingNeedsAnalysisStylesProps {
  isMobile: boolean;
}

export const useStyles = makeStyles((theme) => ({
  "@global": {
    ".k-popup": {
      zIndex: "99999 !important",
    },
    ".k-popup.k-popup-transparent": {
      zIndex: "99999 !important",
    },
    ".k-calendar": {
      zIndex: "99999 !important",
    },
    ".k-animation-container": {
      zIndex: "99999 !important",
    },
  },
  ...getSharedStyles(theme),
  headerDescription: {
    fontSize: "16px",
    color: SURVEY_COLORS.TEXT_SECONDARY,
    marginBottom: "16px",
    textAlign: "center",
  },
  cardTitle: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "8px",
    textAlign: "center",
  },
  questionItem: {
    marginBottom: "32px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "stretch",
    },
  },
  contentCard: {
    backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    borderRadius: "8px",
    padding: "24px",
    marginBottom: "16px",
    boxShadow: SURVEY_COLORS.BOX_SHADOW,
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: (props: TrainingNeedsAnalysisStylesProps) =>
      props.isMobile ? "none" : "calc(90vh - 300px)",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
      padding: "16px",
    },
    "& > div:has(.commissioning-date-field)": {
      display: "inline-block",
      verticalAlign: "top",
      width: "calc(50% - 8px)",
    },
    "& > div:has(.commissioning-date-field) + div:has(.commissioning-date-field)": {
      marginLeft: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
      padding: "16px",
      "& > div:has(.commissioning-date-field)": {
        display: "block",
        width: "100%",
      },
      "& > div:has(.commissioning-date-field) + div:has(.commissioning-date-field)": {
        marginLeft: 0,
      },
    },
  },
  userInfoWrapper: {
    marginBottom: "24px",
  },
  userInfoSection: {
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: "8px",
    padding: "16px",
  },
  userInfoTitle: {
    display: "block",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#1e3a8a",
    margin: "0 0 12px 0",
  },
  userInfoGrid: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0 -6px",
    fontSize: "14px",
    "& > *": {
      boxSizing: "border-box",
      marginBottom: "12px",
      padding: "0 6px",
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      "& > *": {
        width: "50%",
      },
    },
  },
  userInfoLabel: {
    color: "#1d4ed8",
    display: "inline-block",
    fontWeight: 600,
  },
}));
